export default __webpack_public_path__ + "static/media/comprovante2.948989c4.png";